<template>
  <div class="app-container">
    <div class="top_tab flex_center_between">
      <div @click="branchTmp('my')" class="notActive">
        我的
      </div>
      <div class="notActive" @click="branchTmp('stu')" v-if="userInfo.roleFlag">学生</div>
      <div @click="branchTmp('tea')" v-if="userInfo.branchListTeacher.length > 0" class="notActive">教职工</div>
      <div class="active" v-if="userInfo.roleFlag">住宿生</div>
    </div>
    <van-dropdown-menu active-color="#ee0a24" :class="{'boxShadow_none': userInfo.branchListTeacher.length > 0}">
      <van-dropdown-item :title="className" ref="classPicker">
        <van-picker title="请选择班级" value-key='branchName' ref="branchName" show-toolbar :default-index="classIndex" :columns="userInfo.branchList" @confirm="selectClass" @cancel="cancelClass" />
      </van-dropdown-item>
      <van-dropdown-item :title="currentDay" @open="openDate" ref="datePicker">
        <van-datetime-picker v-model="date" type="date" :max-date="maxDate" @confirm="selectDate" @cancel="cancelDate" title="请选择年月日" />
      </van-dropdown-item>
      <van-dropdown-item :title="timeName" ref="timePicker">
        <van-picker title="请选择时段" value-key='periodName' ref="periodName" show-toolbar :default-index="timeIndex" :columns="timeList" @confirm="selectTime" @cancel="cancelTime" />
      </van-dropdown-item>
    </van-dropdown-menu>
    <div class="content" :class="{'withTabHeight': userInfo.branchListTeacher.length > 0}">
      <div class="title fontBold">
        <span>班级住宿生考勤数据</span>
        <span class="fontSize14">{{timeName && periodBeginTime && periodEndTime ? '（' + timeName + '：'  + periodBeginTime + '~' + periodEndTime + '）' : ''}}</span>
      </div>
      <div class="data fontSize14 marginTop5 fontBold text_c">
        <van-row>
          <van-col span="6">人数</van-col>
          <van-col span="6">&nbsp;已考勤</van-col>
          <van-col span="6">&nbsp;未考勤</van-col>
          <van-col span="6">体温异常</van-col>
        </van-row>
        <van-row class="marginTop5">
          <van-col span="6">{{classStudentCount}}</van-col>
          <van-col span="6">{{attendStudentCount}}</van-col>
          <van-col span="6">{{noAttendStudentCount}}</van-col>
          <van-col span="6">{{exceptionStudentCount}}</van-col>
        </van-row>
      </div>
      <div class="title fontBold">
        <span>
          详细数据
        </span>

      </div>
      <div class="table fontSize14 text_c marginTop5">
        <van-row class="fontBold marginBottom5">
          <van-col span="6">序号</van-col>
          <van-col span="6">学生姓名</van-col>
          <van-col span="6">体温</van-col>
          <van-col span="6">考勤时间</van-col>
        </van-row>
        <div v-if="temperatureList.length === 0" class="resultTable">
          暂无数据
        </div>
        <div v-if="temperatureList.length > 0" class="resultTable">
          <van-row v-for="(item,index) in temperatureList" :class="{'marginBottom5': index !== temperatureList.length - 1 }">
            <van-col span="6">{{index + 1}}</van-col>
            <van-col span="6">{{item.studentName}}</van-col>
            <van-col span="6" :class="{'fontColorRed': item.flag === 1}">{{item.animalHeat ? item.animalHeat : '--'}}</van-col>
            <van-col span="6">{{item.attendanceDate ? item.attendanceDate : '--'}}</van-col>
          </van-row>
        </div>
      </div>
      <loading :loading="isLoading"></loading>
      <floatBtn @onFloatBtnClicked="abnormalTmp" :isImg="true" :img="abnormalImg"></floatBtn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils/index'
import { getClassBoarderStatCard, getClassBoarderShiftPeriodList } from '@/api'
import loading from '@/components/loading'
import floatBtn from '@/components/floatBtn'
export default {
  computed: {
    ...mapGetters(['userInfo'])
  },
  components: { loading, floatBtn },
  data () {
    return {
      activeTab: 0,
      classId: '',
      className: '',
      currentDay: '',
      date: new Date(),
      maxDate: new Date(),
      timeId: '',
      timeName: '',
      showDatePicker: false,
      showClassPicker: false,
      timeList: [],
      classList: [],
      classIndex: 0,
      timeIndex: 0,
      temperatureList: [], // 测温表格
      periodBeginTime: '',
      periodEndTime: '',
      classStudentCount: 0,
      noAttendStudentCount: 0,
      attendStudentCount: 0,
      exceptionStudentCount: 0,
      isLoading: true,
      abnormalImg: ''
    }
  },
  created () {
    // 默认展示第一个班级的id
    this.classId = this.userInfo.branchList[0].branchId
    this.classIndex = 0
    this.className = this.userInfo.branchList[0].branchName
    // 默认当天日期
    this.currentDay = parseTime(this.date, '{y}-{m}-{d}')
    this.getClassBoarderShiftPeriodList()
  },
  methods: {
    // 获取班级所在时段
    getClassBoarderShiftPeriodList () {
      this.isLoading = true
      getClassBoarderShiftPeriodList({
        classId: this.classId,
        date: this.currentDay
      })
        .then(res => {
          this.timeList = []
          if (res && res.data.length > 0) {
            this.timeList = res.data
            // 默认展示第一个时段的数据
            this.timeIndex = 0
            this.timeName = this.timeList[0].periodName
            this.getClassBoarderStatCard()
          } else {
            this.timeName = ''
            this.timeList = []
            this.periodBeginTime = ''
            this.periodEndTime = ''
            this.handleEmpty()
          }
        })
        .catch(err => {
          this.timeName = ''
          this.periodBeginTime = ''
          this.periodEndTime = ''
          this.timeList = []
          this.handleEmpty()
        })
    },
    // 无数据处理
    handleEmpty () {
      this.abnormalImg = require('../../assets/img/normal.png')
      this.temperatureList = []
      this.classStudentCount = 0
      this.attendStudentCount = 0
      this.noAttendStudentCount = 0
      this.exceptionStudentCount = 0
      this.isLoading = false
    },
    // 选择班级
    selectClass (value, index) {
      this.classIndex = index
      this.className = value.branchName
      this.classId = value.branchId
      this.$refs.classPicker.toggle()
      this.getClassBoarderShiftPeriodList()
    },
    // 取消选择班级
    cancelClass () {
      this.$refs.branchName.setIndexes([this.classIndex])
      this.$refs.classPicker.toggle()
    },
    openDate () {
      this.date = new Date(this.currentDay)
    },
    // 选择日期
    selectDate (value) {
      this.currentDay = parseTime(value, '{y}-{m}-{d}')
      this.$refs.datePicker.toggle()
      this.getClassBoarderShiftPeriodList()
    },
    cancelDate () {
      this.$refs.datePicker.toggle()
    },
    // 选择时段
    selectTime (value, index) {
      this.timeIndex = index
      this.timeName = value.periodName
      this.$refs.timePicker.toggle()
      this.getClassBoarderStatCard()
    },
    cancelTime () {
      this.$refs.periodName.setIndexes([this.timeIndex])
      this.$refs.timePicker.toggle()
    },

    // 获取班级当日时段学生考勤数据
    getClassBoarderStatCard () {
      this.isLoading = true
      const periodTime = this.timeList.filter(item => {
        return item.periodName === this.timeName
      })
      this.periodBeginTime = periodTime[0].periodBeginTime
      this.periodEndTime = periodTime[0].periodEndTime
      getClassBoarderStatCard({
        classId: this.classId,
        periodBeginDate: this.currentDay + ' ' + this.periodBeginTime,
        periodEndDate: this.currentDay + ' ' + this.periodEndTime
      })
        .then(res => {
          if (res.code === 200) {
            if (res.data) {
              this.classStudentCount = res.data.classStudentCount
              this.attendStudentCount = res.data.attendStudentCount
              this.noAttendStudentCount = res.data.noAttendStudentCount
              this.temperatureList = res.data.students
              this.exceptionStudentCount = res.data.exceptionStudents
                ? res.data.exceptionStudents.length
                : 0
              if (this.exceptionStudentCount === 0) {
                this.abnormalImg = require('../../assets/img/normal.png')
              } else {
                this.abnormalImg = require('../../assets/img/abnormal.png')
              }
            }
            this.isLoading = false
          } else {
            this.handleEmpty()
          }
        })
        .catch(err => {
          this.handleEmpty()
        })
    },
    // 异常体温
    abnormalTmp () {
      this.$router.push({
        path: '/abnormalTemperature',
        query: {
          type: 'dorm'
        }
      })
    },
    // 部门体温
    branchTmp (type) {
      if (type === 'my') {
        this.$router.push('/my')
      } else if (type === 'stu') {
        if (this.userInfo.roleFlag === 'CLASS') {
          // 班级
          this.$router.push('/classTemperature')
        } else if (this.userInfo.roleFlag === 'GRADE') {
          // 年级
          this.$router.push('/gradeTemperature')
        }
      } else {
        this.$router.push('/teacherTemperature')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.app-container {
  background-color: #eff5fd;
  ::v-deep .van-popup--top {
    bottom: 0;
    top: unset;
  }
  ::v-deep .van-picker__confirm {
    color: #ee0a24;
  }
  .withTabHeight {
    height: calc(100% - 72px) !important;
  }
  .content {
    padding: 10px;
    height: calc(100% - 50px);
    .title {
      height: 30px;
      line-height: 30px;
      span:nth-child(1) {
        color: rgb(5, 182, 252);
      }
    }
    .data,
    .table {
      line-height: 20px;
      background: #cce3ff;
      padding: 10px;
      border-radius: 5px;
    }
    .table {
      padding: 10px 5px;
      max-height: calc(100% - 140px);
      display: flex;
      flex-flow: column;
    }
    .resultTable {
      padding: 5px 0;
      border-radius: 5px;
      flex: 1;
      background-color: #fff;
      overflow-y: auto;
    }
  }
}
</style>